import {
  MasterArtworkSearchActionType,
  MasterArtworkSearchActionTypes,
} from "./data.type";

const setArtworkLevel = (
  artworkLevel: string,
): MasterArtworkSearchActionType => ({
  type: MasterArtworkSearchActionTypes.SET_ARTWORK_LEVEL,
  payload: { artworkLevel },
});

const setSearchCollection = (
  searchCollection: string | null,
): MasterArtworkSearchActionType => ({
  type: MasterArtworkSearchActionTypes.SET_SEARCH_COLLECTION,
  payload: { searchCollection },
});

const setSearchMetaArtwork = (
  searchMetaArtwork: string | null,
): MasterArtworkSearchActionType => ({
  type: MasterArtworkSearchActionTypes.SET_SEARCH_META_ARTWORK,
  payload: { searchMetaArtwork },
});

const setSearchPrintingTechnique = (
  searchPrintingTechnique: string | null,
): MasterArtworkSearchActionType => ({
  type: MasterArtworkSearchActionTypes.SET_SEARCH_PRINTING_TECHNIQUE,
  payload: { searchPrintingTechnique },
});

const setAppliedFiltersCollection = (
  appliedFiltersCollection: any,
): MasterArtworkSearchActionType => ({
  type: MasterArtworkSearchActionTypes.SET_APPLIED_FILTERS_COLLECTION,
  payload: { appliedFiltersCollection },
});

const setAppliedFiltersMetaArtwork = (
  appliedFiltersMetaArtwork: any,
): MasterArtworkSearchActionType => ({
  type: MasterArtworkSearchActionTypes.SET_APPLIED_FILTERS_META_ARTWORK,
  payload: { appliedFiltersMetaArtwork },
});

const setAppliedFiltersPrintingTechnique = (
  appliedFiltersPrintingTechnique: any,
): MasterArtworkSearchActionType => ({
  type: MasterArtworkSearchActionTypes.SET_APPLIED_FILTERS_PRINTING_TECHNIQUE,
  payload: { appliedFiltersPrintingTechnique },
});

const setCurrentPageCollection = (
  currentPageCollection: number,
): MasterArtworkSearchActionType => ({
  type: MasterArtworkSearchActionTypes.SET_CURRENT_PAGE_COLLECTION,
  payload: { currentPageCollection },
});

const setCurrentPageMetaArtwork = (
  currentPageMetaArtwork: number,
): MasterArtworkSearchActionType => ({
  type: MasterArtworkSearchActionTypes.SET_CURRENT_PAGE_META_ARTWORK,
  payload: { currentPageMetaArtwork },
});

const setCurrentPagePrintingTechnique = (
  currentPagePrintingTechnique: number,
): MasterArtworkSearchActionType => ({
  type: MasterArtworkSearchActionTypes.SET_CURRENT_PAGE_PRINTING_TECHNIQUE,
  payload: { currentPagePrintingTechnique },
});

const setResponseDataCollection = (
  responseDataCollection: any | null,
): MasterArtworkSearchActionType => ({
  type: MasterArtworkSearchActionTypes.SET_RESPONSE_DATA_COLLECTION,
  payload: { responseDataCollection },
});

const setResponseDataMetaArtwork = (
  responseDataMetaArtwork: any | null,
): MasterArtworkSearchActionType => ({
  type: MasterArtworkSearchActionTypes.SET_RESPONSE_DATA_META_ARTWORK,
  payload: { responseDataMetaArtwork },
});

const setResponseDataPrintingTechnique = (
  responseDataPrintingTechnique: any | null,
): MasterArtworkSearchActionType => ({
  type: MasterArtworkSearchActionTypes.SET_RESPONSE_DATA_PRINTING_TECHNIQUE,
  payload: { responseDataPrintingTechnique },
});

const setLimitCollection = (
  limitCollection: number,
): MasterArtworkSearchActionType => ({
  type: MasterArtworkSearchActionTypes.SET_LIMIT_COLLECTION,
  payload: { limitCollection },
});

const setLimitMetaArtwork = (
  limitMetaArtwork: number,
): MasterArtworkSearchActionType => ({
  type: MasterArtworkSearchActionTypes.SET_LIMIT_META_ARTWORK,
  payload: { limitMetaArtwork },
});

const setLimitPrintingTechnique = (
  limitPrintingTechnique: number,
): MasterArtworkSearchActionType => ({
  type: MasterArtworkSearchActionTypes.SET_LIMIT_PRINTING_TECHNIQUE,
  payload: { limitPrintingTechnique },
});

export const MasterArtworkSearchActions = {
  setArtworkLevel,
  setSearchCollection,
  setSearchMetaArtwork,
  setSearchPrintingTechnique,
  setAppliedFiltersCollection,
  setAppliedFiltersMetaArtwork,
  setAppliedFiltersPrintingTechnique,
  setCurrentPageCollection,
  setCurrentPageMetaArtwork,
  setCurrentPagePrintingTechnique,
  setResponseDataCollection,
  setResponseDataMetaArtwork,
  setResponseDataPrintingTechnique,
  setLimitCollection,
  setLimitMetaArtwork,
  setLimitPrintingTechnique,
};

